import React, { Component } from 'react';
import '../styles/canvas.css';

class CanvasComponent extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.clearButtonRef = React.createRef();
    this.clearAllRef = React.createRef();
    this.colorPickerRef = React.createRef();
    this.sizeSliderRef = React.createRef();
    this.fillModeRef = React.createRef();
    this.path = [];
    this.fillMode = false;
    this.state = {
      currentColor: '#000000',
      currentSize: 3,
    };
  }

  componentDidMount() {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    let drawing = false;

    const getPos = (e) => {
      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;

      if (e.touches && e.touches.length > 0) {
        // Touch event
        return {
          x: (e.touches[0].clientX - rect.left) * scaleX,
          y: (e.touches[0].clientY - rect.top) * scaleY,
        };
      } else {
        // Mouse event
        return {
          x: (e.clientX - rect.left) * scaleX,
          y: (e.clientY - rect.top) * scaleY,
        };
      }
    };

    const startDrawing = (e) => {
      const pos = getPos(e);

      if (this.fillMode) {
        // Mode pot de peinture
        this.floodFill(Math.floor(pos.x), Math.floor(pos.y), this.state.currentColor);
        this.path.push(ctx.getImageData(0, 0, canvas.width, canvas.height));
      } else {
        // Mode dessin normal
        drawing = true;
        ctx.beginPath();
        ctx.strokeStyle = this.state.currentColor;
        ctx.lineCap = 'round';
        ctx.moveTo(pos.x, pos.y);
      }
      if (e.touches) {
        e.preventDefault();
      }
    };

    const draw = (e) => {
      if (!drawing || this.fillMode) return;
      const pos = getPos(e);
      ctx.lineTo(pos.x, pos.y);
      ctx.stroke();
      if (e.touches) {
        e.preventDefault();
      }
    };

    const stopDrawing = () => {
      if (!this.fillMode && drawing) {
        drawing = false;
        ctx.closePath();
        this.path.push(ctx.getImageData(0, 0, canvas.width, canvas.height));
      }
    };

    // Touch events
    canvas.addEventListener('touchstart', startDrawing);
    canvas.addEventListener('touchmove', draw);
    canvas.addEventListener('touchend', stopDrawing);

    // Mouse events
    canvas.addEventListener('mousedown', startDrawing);
    canvas.addEventListener('mousemove', draw);
    canvas.addEventListener('mouseup', stopDrawing);
    canvas.addEventListener('mouseleave', stopDrawing);

    this.clearButtonRef.current.addEventListener('click', () => {
      if (this.path.length > 0) {
        this.clearCanvas();
        this.path.pop();
        this.path.forEach((pathData) => ctx.putImageData(pathData, 0, 0));
      }
    });

    this.clearAllRef.current.addEventListener('click', () => {
      this.clearCanvas();
      this.path = [];
    });

    this.colorPickerRef.current.addEventListener('input', (e) => {
      const selectedColor = e.target.value;
      this.setState({ currentColor: selectedColor });
      ctx.strokeStyle = selectedColor;
      ctx.fillStyle = selectedColor;
    });

    this.sizeSliderRef.current.addEventListener('input', (e) => {
      const size = parseInt(e.target.value);
      this.setState({ currentSize: size });
      ctx.lineWidth = size;
    });

    this.fillModeRef.current.addEventListener('change', (e) => {
      this.fillMode = e.target.checked;
    });

    ctx.lineWidth = 3;
  }

  clearCanvas = () => {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };

  floodFill = (startX, startY, fillColor) => {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const pixels = imageData.data;
    const width = canvas.width;
    const height = canvas.height;

    // Vérifier que les coordonnées sont valides
    if (startX < 0 || startX >= width || startY < 0 || startY >= height) {
      return;
    }

    const startPos = (startY * width + startX) * 4;
    const startR = pixels[startPos];
    const startG = pixels[startPos + 1];
    const startB = pixels[startPos + 2];
    const startA = pixels[startPos + 3];

    // Convert hex color to RGB
    const hex = fillColor.replace('#', '');
    const fillR = parseInt(hex.substring(0, 2), 16);
    const fillG = parseInt(hex.substring(2, 4), 16);
    const fillB = parseInt(hex.substring(4, 6), 16);

    // If the clicked color is the same as fill color, return
    if (startR === fillR && startG === fillG && startB === fillB && startA === 255) {
      return;
    }

    const visited = new Set();
    const pixelStack = [[startX, startY]];

    while (pixelStack.length > 0) {
      const [x, y] = pixelStack.pop();

      if (x < 0 || x >= width || y < 0 || y >= height) continue;

      const key = y * width + x;
      if (visited.has(key)) continue;
      visited.add(key);

      const pos = key * 4;

      if (
        pixels[pos] === startR &&
        pixels[pos + 1] === startG &&
        pixels[pos + 2] === startB &&
        pixels[pos + 3] === startA
      ) {
        pixels[pos] = fillR;
        pixels[pos + 1] = fillG;
        pixels[pos + 2] = fillB;
        pixels[pos + 3] = 255;

        pixelStack.push([x + 1, y]);
        pixelStack.push([x - 1, y]);
        pixelStack.push([x, y + 1]);
        pixelStack.push([x, y - 1]);
      }
    }

    ctx.putImageData(imageData, 0, 0);
  };

  exportCanvasAsPNG = () => {
    const canvas = this.canvasRef.current;
    var unityID = localStorage.getItem('UNITY');
    var pseudo = localStorage.getItem('pseudo');
    var pseudoColor = localStorage.getItem('pseudoColor');
    const { ws, onExportSuccess } = this.props;

    // Obtenez les données de l'image en format base64
    const imageDataURL = canvas.toDataURL('image/png', 0.9);

    ws.send(unityID + ':NPþ' + pseudo + 'þ' + pseudoColor + 'þPICþTRUEþ' + imageDataURL);
    onExportSuccess();
  };

  render() {
    return (
      <div className="canvas-container">
        <h1 className="title">{this.props.translations.canvas.title}</h1>
        <canvas
          ref={this.canvasRef}
          width={350}
          height={350}
          className="drawing-canvas"
        ></canvas>
        <div className="radio-groups-container">
          <div className="color-picker-group">
            <label htmlFor="colorPicker" className="canvas-label-picker">
              {this.props.translations.canvas.colorLabel}
            </label>
            <input
              type="color"
              id="colorPicker"
              ref={this.colorPickerRef}
              defaultValue="#000000"
              className="color-picker-input"
            />
          </div>
          <div className="size-slider-group">
            <label htmlFor="sizeSlider" className="canvas-label-picker">
              {this.props.translations.canvas.sizeLabel} <span className="size-value">{this.state.currentSize}px</span>
            </label>
            <input
              type="range"
              id="sizeSlider"
              ref={this.sizeSliderRef}
              min="1"
              max="20"
              defaultValue="3"
              className="size-slider-input"
            />
          </div>
          <div className="fill-mode-group">
            <label htmlFor="fillMode" className="fill-mode-label">
              <input
                type="checkbox"
                id="fillMode"
                ref={this.fillModeRef}
                className="fill-mode-checkbox"
              />
              <span className="fill-mode-text">{this.props.translations.canvas.fillMode}</span>
            </label>
          </div>
        </div>
        <div className="buttons-container">
          <button ref={this.clearButtonRef} className="canvas-button canvas-button-secondary">{this.props.translations.canvas.undoButton}</button>
          <button ref={this.clearAllRef} className="canvas-button canvas-button-secondary">{this.props.translations.canvas.clearButton}</button>
          <button onClick={this.exportCanvasAsPNG} className="submit-button">{this.props.translations.canvas.submit}</button>
        </div>
      </div>
    );
  }
}

export default CanvasComponent;
